var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"id":"toTop-form","action":"#home"},on:{"click":function($event){$event.preventDefault();return _vm.scrollTo('#home')}}},[_c('button',{staticClass:"has-background-primary",attrs:{"id":"toTop-btn","title":"Go to top"}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'angle-up']}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }